import { useState } from "react";
import { Mail } from "lucide-react";
import { CATEGORIES, PRODUCTS, CONTACT_EMAIL } from "../data";
import { Breadcrumb } from "../Layout";

export default function Produits() {
  const [filter, setFilter] = useState("tous");
  return (
    <div className="mx-auto max-w-6xl px-4 py-14 sm:px-8">
      <Breadcrumb items={[{ label: "Accueil", to: "/" }, { label: "Produits" }]} />
      <p className="tag-mono mb-4 text-[#E4C5B3]">Catalogue professionnel</p>
      <h1 className="max-w-3xl font-display text-4xl font-medium leading-[1.1] tracking-tight sm:text-5xl">
        Des gammes complètes pour la prothésie ongulaire
      </h1>
      <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400 sm:text-lg">
        Gels de construction, bases et top coats, vernis semi-permanent, fraises et embouts de ponceuse,
        nail art : les essentiels du poste de travail, sélectionnés pour un usage professionnel.
      </p>

      <div role="tablist" aria-label="Filtrer par gamme" className="mt-10 flex flex-wrap gap-2">
        {[{ id: "tous", label: "Tous" }, ...CATEGORIES].map((c) => (
          <button
            key={c.id}
            type="button"
            role="tab"
            aria-selected={filter === c.id}
            data-testid={`filter-tab-${c.id}`}
            onClick={() => setFilter(c.id)}
            className={`filter-tab ${filter === c.id ? "filter-tab-active" : ""}`}
          >
            {c.label}
          </button>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {PRODUCTS.map((p) => (
          <article
            key={p.id}
            id={p.cat}
            data-testid={`product-card-${p.id}`}
            className={`flex flex-col border border-white/10 bg-[#15151C] p-6 transition-colors hover:border-[#E4C5B3]/40 ${
              filter !== "tous" && filter !== p.cat ? "hidden" : ""
            }`}
          >
            <p className="tag-mono text-[#E4C5B3]">{CATEGORIES.find((c) => c.id === p.cat).label}</p>
            <h2 className="mt-3 font-display text-xl font-medium leading-snug">{p.name}</h2>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-zinc-400">{p.desc}</p>
            <div className="mt-5 flex flex-wrap gap-2">
              {p.tags.map((t) => (
                <span key={t} className="tag-mono border border-white/10 px-2 py-1 text-zinc-500">
                  {t}
                </span>
              ))}
            </div>
          </article>
        ))}
      </div>

      <div className="mt-14 border border-[#E4C5B3]/25 bg-[#1C1C26] p-8 sm:p-10">
        <h2 className="font-display text-2xl font-medium tracking-tight">Références, disponibilité et tarifs</h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-zinc-400">
          Le catalogue évolue et certaines références peuvent être temporairement indisponibles. Pour connaître
          les références et les tarifs en cours, écrivez-nous : nous vous répondrons personnellement.
        </p>
        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="produits-contact-cta" className="btn-primary mt-6">
          <Mail size={16} aria-hidden="true" /> Demander les tarifs
        </a>
      </div>
    </div>
  );
}
